import { render, staticRenderFns } from "./_category.vue?vue&type=template&id=37eab516&"
import script from "./_category.vue?vue&type=script&lang=js&"
export * from "./_category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlogCard: require('/opt/build/repo/components/Blog/Card.vue').default})
